var path = 'components/contentSearchResults/contentSearchResults.template.html';
var html = "<smb-document-hit-list documents=vm.contentSearchDS.documents view-on-select=true></smb-document-hit-list>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/components/contentSearchResults/contentSearchResults.template.html
// module id = 166
// module chunks = 1